// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Crimson+Text:wght@700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgba(0, 0, 0, 0.799);
  letter-spacing: 0.5px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.img-col {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 41.666667%; /* Equivalent to col-md-5's width in Bootstrap */
  z-index: 10;
}

.img-col img {
  object-fit: cover;
  height: 100%;
  width: 100%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.img-wrapper {
  position: relative;
  display: block;
  height: 100vh;
}

.img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.right-col {
  margin-left: 41.666667%; /* Push the right column to the right */
  height: 100vh;
  overflow-y: auto; /* Makes it independently scrollable */
}

.section-wrapper {
  border: 1px solid lightblue;
  border-radius: 5px;
}

.section-wrapper1{
  border: 1px solid rgb(235, 232, 232);
  border-radius: 5px;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid orange;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.required::after {
  content: "*";
  color: red;
  margin-left: 5px;
}

.custom-font {
  font-family: "Crimson Text", serif;
  font-weight: 400;
  margin-top: 50px !important;
  margin-bottom: 30px !important;
}

/* MOBILE DESIGN */

@media screen and (max-width: 768px) {
  .img-col {
    display: none;
  }
  .right-col {
    margin-left: 0;
  }

  .custom-font {
    font-size: 19px;
    font-weight: bold;
  }
}

/* LOGIN FORM CSS */
body {
  font-family: "Roboto", sans-serif;
  background-color: #fff;
}

p {
  color: #b3b3b3;
  font-weight: 300;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Roboto", sans-serif;
}

a {
  transition: 0.3s all ease;
}
a:hover {
  text-decoration: none !important;
}

.content {
  padding: 7rem 0;
}

h2 {
  font-size: 20px;
}

.half,
.half .container > .row {
  height: 100vh;
  min-height: 700px;
}

@media (max-width: 991.98px) {
  .half .bg {
    height: 200px;
  }
}

.half .contents {
  background: #f6f7fc;
}

.half .contents,
.half .bg {
  width: 50%;
}
@media (max-width: 1199.98px) {
  .half .contents,
  .half .bg {
    width: 100%;
  }
}
.half .contents .form-control,
.half .bg .form-control {
  border: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  height: 54px;
  background: #fff;
}
.half .contents .form-control:active,
.half .contents .form-control:focus,
.half .bg .form-control:active,
.half .bg .form-control:focus {
  outline: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.half .bg {
  background-size: cover;
  background-position: center;
}

.half a {
  color: #888;
  text-decoration: underline;
}

.half .btn {
  height: 54px;
  padding-left: 30px;
  padding-right: 30px;
}

.half .forgot-pass {
  position: relative;
  top: 2px;
  font-size: 14px;
}

.control {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 14px;
}
.control .caption {
  position: relative;
  top: 0.2rem;
  color: #888;
}

.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
  border-radius: 4px;
}

.control--radio .control__indicator {
  border-radius: 50%;
}

.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}

.control input:checked ~ .control__indicator {
  background: #fb771a;
}

.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #fb8633;
}

.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.9;
  pointer-events: none;
}

.control__indicator:after {
  font-family: "icomoon";
  content: "\\e5ca";
  position: absolute;
  display: none;
  font-size: 16px;
  transition: 0.3s all ease;
}

.control input:checked ~ .control__indicator:after {
  display: block;
  color: #fff;
}

.control--checkbox .control__indicator:after {
  top: 50%;
  left: 50%;
  margin-top: -1px;
  transform: translate(-50%, -50%);
}

.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}

.control--checkbox input:disabled:checked ~ .control__indicator {
  background-color: #7e0cf5;
  opacity: 0.2;
}

.custom-button {
  border-radius: 20px;
  height: 45px !important;
}

.rounded {
  border-radius: 10px !important;
  height: 45px !important;
  border: rgba(0, 0, 0, 0.1) 1px solid !important;
}
.main-cont {
  padding-top: 150px;
}

.img-admin {
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
}

/* Media query for mobile screens */
@media (max-width: 900px) {
  .main-cont {
    padding-top: 50px;
  }

  .img-admin {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .login-wrapper {
    width: 90% !important;
  }
}

.login-wrapper {
  width: 30%;
}

.apply{
  height: 40px !important;
}

.cursor{
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB,EAAE,gDAAgD;EACnE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB,EAAE,uCAAuC;EAChE,aAAa;EACb,gBAAgB,EAAE,sCAAsC;AAC1D;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,kBAAkB;;AAElB;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,iCAAiC;AACnC;;AAEA;EAGE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;AACA;EACE;;IAEE,WAAW;EACb;AACF;AACA;;EAEE,YAAY;EAEZ,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;;;;EAIE,aAAa;EAEb,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;EAGf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,gBAAgB;EAGhB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,+CAA+C;AACjD;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Crimson+Text:wght@700&display=swap\");\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\r\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  color: rgba(0, 0, 0, 0.799);\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\r\n    monospace;\r\n}\r\n\r\n.img-col {\r\n  position: fixed;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100vh;\r\n  width: 41.666667%; /* Equivalent to col-md-5's width in Bootstrap */\r\n  z-index: 10;\r\n}\r\n\r\n.img-col img {\r\n  object-fit: cover;\r\n  height: 100%;\r\n  width: 100%;\r\n  border-top-right-radius: 30px;\r\n  border-bottom-right-radius: 30px;\r\n}\r\n\r\n.img-wrapper {\r\n  position: relative;\r\n  display: block;\r\n  height: 100vh;\r\n}\r\n\r\n.img-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.3);\r\n  border-top-right-radius: 30px;\r\n  border-bottom-right-radius: 30px;\r\n}\r\n\r\n.center {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.right-col {\r\n  margin-left: 41.666667%; /* Push the right column to the right */\r\n  height: 100vh;\r\n  overflow-y: auto; /* Makes it independently scrollable */\r\n}\r\n\r\n.section-wrapper {\r\n  border: 1px solid lightblue;\r\n  border-radius: 5px;\r\n}\r\n\r\n.section-wrapper1{\r\n  border: 1px solid rgb(235, 232, 232);\r\n  border-radius: 5px;\r\n}\r\n\r\n.loader {\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid orange;\r\n  border-radius: 50%;\r\n  width: 35px;\r\n  height: 35px;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.required::after {\r\n  content: \"*\";\r\n  color: red;\r\n  margin-left: 5px;\r\n}\r\n\r\n.custom-font {\r\n  font-family: \"Crimson Text\", serif;\r\n  font-weight: 400;\r\n  margin-top: 50px !important;\r\n  margin-bottom: 30px !important;\r\n}\r\n\r\n/* MOBILE DESIGN */\r\n\r\n@media screen and (max-width: 768px) {\r\n  .img-col {\r\n    display: none;\r\n  }\r\n  .right-col {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .custom-font {\r\n    font-size: 19px;\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n/* LOGIN FORM CSS */\r\nbody {\r\n  font-family: \"Roboto\", sans-serif;\r\n  background-color: #fff;\r\n}\r\n\r\np {\r\n  color: #b3b3b3;\r\n  font-weight: 300;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n  font-family: \"Roboto\", sans-serif;\r\n}\r\n\r\na {\r\n  -webkit-transition: 0.3s all ease;\r\n  -o-transition: 0.3s all ease;\r\n  transition: 0.3s all ease;\r\n}\r\na:hover {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.content {\r\n  padding: 7rem 0;\r\n}\r\n\r\nh2 {\r\n  font-size: 20px;\r\n}\r\n\r\n.half,\r\n.half .container > .row {\r\n  height: 100vh;\r\n  min-height: 700px;\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .half .bg {\r\n    height: 200px;\r\n  }\r\n}\r\n\r\n.half .contents {\r\n  background: #f6f7fc;\r\n}\r\n\r\n.half .contents,\r\n.half .bg {\r\n  width: 50%;\r\n}\r\n@media (max-width: 1199.98px) {\r\n  .half .contents,\r\n  .half .bg {\r\n    width: 100%;\r\n  }\r\n}\r\n.half .contents .form-control,\r\n.half .bg .form-control {\r\n  border: none;\r\n  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\r\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\r\n  border-radius: 4px;\r\n  height: 54px;\r\n  background: #fff;\r\n}\r\n.half .contents .form-control:active,\r\n.half .contents .form-control:focus,\r\n.half .bg .form-control:active,\r\n.half .bg .form-control:focus {\r\n  outline: none;\r\n  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\r\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.half .bg {\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\n.half a {\r\n  color: #888;\r\n  text-decoration: underline;\r\n}\r\n\r\n.half .btn {\r\n  height: 54px;\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n}\r\n\r\n.half .forgot-pass {\r\n  position: relative;\r\n  top: 2px;\r\n  font-size: 14px;\r\n}\r\n\r\n.control {\r\n  display: block;\r\n  position: relative;\r\n  padding-left: 30px;\r\n  margin-bottom: 15px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n.control .caption {\r\n  position: relative;\r\n  top: 0.2rem;\r\n  color: #888;\r\n}\r\n\r\n.control input {\r\n  position: absolute;\r\n  z-index: -1;\r\n  opacity: 0;\r\n}\r\n\r\n.control__indicator {\r\n  position: absolute;\r\n  top: 2px;\r\n  left: 0;\r\n  height: 20px;\r\n  width: 20px;\r\n  background: #e6e6e6;\r\n  border-radius: 4px;\r\n}\r\n\r\n.control--radio .control__indicator {\r\n  border-radius: 50%;\r\n}\r\n\r\n.control:hover input ~ .control__indicator,\r\n.control input:focus ~ .control__indicator {\r\n  background: #ccc;\r\n}\r\n\r\n.control input:checked ~ .control__indicator {\r\n  background: #fb771a;\r\n}\r\n\r\n.control:hover input:not([disabled]):checked ~ .control__indicator,\r\n.control input:checked:focus ~ .control__indicator {\r\n  background: #fb8633;\r\n}\r\n\r\n.control input:disabled ~ .control__indicator {\r\n  background: #e6e6e6;\r\n  opacity: 0.9;\r\n  pointer-events: none;\r\n}\r\n\r\n.control__indicator:after {\r\n  font-family: \"icomoon\";\r\n  content: \"\\e5ca\";\r\n  position: absolute;\r\n  display: none;\r\n  font-size: 16px;\r\n  -webkit-transition: 0.3s all ease;\r\n  -o-transition: 0.3s all ease;\r\n  transition: 0.3s all ease;\r\n}\r\n\r\n.control input:checked ~ .control__indicator:after {\r\n  display: block;\r\n  color: #fff;\r\n}\r\n\r\n.control--checkbox .control__indicator:after {\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-top: -1px;\r\n  -webkit-transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n.control--checkbox input:disabled ~ .control__indicator:after {\r\n  border-color: #7b7b7b;\r\n}\r\n\r\n.control--checkbox input:disabled:checked ~ .control__indicator {\r\n  background-color: #7e0cf5;\r\n  opacity: 0.2;\r\n}\r\n\r\n.custom-button {\r\n  border-radius: 20px;\r\n  height: 45px !important;\r\n}\r\n\r\n.rounded {\r\n  border-radius: 10px !important;\r\n  height: 45px !important;\r\n  border: rgba(0, 0, 0, 0.1) 1px solid !important;\r\n}\r\n.main-cont {\r\n  padding-top: 150px;\r\n}\r\n\r\n.img-admin {\r\n  border-bottom-left-radius: 15px;\r\n  border-top-left-radius: 15px;\r\n}\r\n\r\n/* Media query for mobile screens */\r\n@media (max-width: 900px) {\r\n  .main-cont {\r\n    padding-top: 50px;\r\n  }\r\n\r\n  .img-admin {\r\n    border-bottom-left-radius: 15px;\r\n    border-bottom-right-radius: 15px;\r\n  }\r\n\r\n  .login-wrapper {\r\n    width: 90% !important;\r\n  }\r\n}\r\n\r\n.login-wrapper {\r\n  width: 30%;\r\n}\r\n\r\n.apply{\r\n  height: 40px !important;\r\n}\r\n\r\n.cursor{\r\n  cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
